import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: #000000;
  color: #ffffff;
  padding: 40px 20px 20px;
  margin-top: 40px;
`;

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const FooterTop = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const FooterSection = styled.div`
  font-size: 0.9rem;
`;

export const FooterSectionTitle = styled.h3`
  margin: 0 0 12px;
  font-size: 1rem;
  color: #f5f5f5;
`;

export const FooterLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const FooterLinkItem = styled.li`
  margin-bottom: 8px;

  a {
    color: #d4af37;
    text-decoration: none;
    font-size: 0.9rem;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ContactDetails = styled.div`
  font-size: 0.9rem;

  p {
    margin: 4px 0;
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 16px;
  padding-top: 12px;
  font-size: 0.8rem;
  text-align: center;
`;

export const Copyright = styled.div``;
